export const FETCH_QUESTIONS = "[Question] Fetch Data";
export const UPDATE_QUESTION = "[Question] Update Item";
export const CREATE_QUESTION = "[Question] Create Item";
